var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:`icon icon--${_vm.name}`,on:{"click":function($event){return _vm.$emit('click')}}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":`${require('/public/sprite.svg')}#${_vm.name}`,"href":`${require('/public/sprite.svg')}#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }